import { Component } from "react"
import PropTypes from "prop-types"

import PopulatorInput from "partners/components/shared/field_type_inputs/populator_input"
import InlineErrors from "shared/components/inline_errors"

class CustomFieldDropdownStaticField extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.hasDefaultValue != this.props.hasDefaultValue &&
      !this.props.hasDefaultValue
    ) {
      this.props.onDefaultValueChange(null)
    }
  }

  handleDefaultValueSelectChange = e => {
    this.props.onDefaultValueChange(e.target.value)
  }

  render() {
    const {
      defaultValue,
      disabled,
      errors,
      hasDefaultValue,
      onPopulatorChange,
    } = this.props
    const populator = this.props.populator || []
    const baseId = `custom-field-${this.props.index}-dropdown-static`

    return (
      <>
        {errors?.populator && errors.populator.length > 0 && (
          <InlineErrors errors={errors["populator"]} />
        )}
        <PopulatorInput
          populator={populator}
          onPopulatorChange={onPopulatorChange}
          disabled={disabled}
        />

        {hasDefaultValue && (
          <div className="field">
            <>
              <div className="label">
                <label htmlFor={`${baseId}-default`}>Default value</label>
              </div>
              <div className="input">
                {errors?.hasDefaultValue &&
                  errors.hasDefaultValue.length > 0 && (
                    <InlineErrors errors={errors["hasDefaultValue"]} />
                  )}
                <select
                  id={`${baseId}-default`}
                  value={defaultValue || "__disabled"}
                  onChange={this.handleDefaultValueSelectChange}
                  disabled={disabled}
                >
                  <option key={-1} value="__disabled" disabled>
                    Select a default option
                  </option>
                  {populator.map((o, index) => (
                    <option key={index} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </select>
              </div>
            </>
          </div>
        )}
      </>
    )
  }
}

CustomFieldDropdownStaticField.propTypes = {
  index: PropTypes.number.isRequired,
  populator: PropTypes.array,
  onPopulatorChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  hasDefaultValue: PropTypes.bool,
  onDefaultValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  fieldType: PropTypes.string,
}

CustomFieldDropdownStaticField.defaultPropTypes = {
  hasDefaultValue: false,
}

export default CustomFieldDropdownStaticField
